import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

function ProgressBar({ progress, isRounded }) {
    return (
        <div className={`progress ${isRounded ? null : 'customProgress'}`}>
            <div
                className="progress-bar"
                style={{ width: `${progress}%` }}
                role="progressbar"
                aria-valuenow={progress}
                aria-valuemin="0"
                aria-valuemax="100"
            ></div>
        </div>
    );
}

ProgressBar.propTypes = {
    // value representing the width of the progress bar
    progress: PropTypes.number,
    // bool to round the edges if inside card
    isRounded: PropTypes.bool,
};

ProgressBar.defaultProps = {
    progress: 0,
    isRounded: false,
};

export default ProgressBar;
